import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Briefcase, Users, FileText, TrendingUp, CheckCircle } from 'lucide-react';

const CompanyManagement = () => {
  const { t } = useTranslation();
  const sp = (key) => t(`service_pages.company_management.${key}`);
  const common = (key) => t(`service_pages.common.${key}`);
  const features = t('features.company_management_features', { returnObjects: true });

  return (
    <>
      <Helmet>
        <title>{sp('meta_title')}</title>
        <meta name="description" content={sp('meta_desc')} />
        <meta name="keywords" content="company management software Thailand, HR system Pattaya, CRM software Thailand, project management system, business automation Thailand" />
        <link rel="canonical" href="https://karnidigitalsolutions.com/services/company-management" />
      </Helmet>

      <section className="pt-24 pb-16 bg-gradient-primary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6" data-aos="fade-up">
              {sp('title')}
            </h1>
            <p className="text-xl md:text-2xl text-gold mb-8 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="200">
              {sp('subtitle')}
            </p>
            <div className="flex flex-wrap gap-4 justify-center" data-aos="fade-up" data-aos-delay="400">
              <Link to="/contact" className="btn-gold">{common('get_quote')}</Link>
              <a href="https://wa.me/66968826252" className="btn-primary" target="_blank" rel="noopener noreferrer">
                {common('whatsapp_us')}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-12 text-center">
            {sp('section_title')}
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start space-x-3" data-aos="fade-up" data-aos-delay={index * 50}>
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                <span className="text-gray-700 font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="card bg-white text-center" data-aos="fade-up">
              <Users className="w-12 h-12 text-primary mx-auto mb-4" />
              <h3 className="text-xl font-bold text-primary mb-2">HR & Payroll</h3>
              <p className="text-gray-600">Employee management & salary</p>
            </div>
            
            <div className="card bg-white text-center" data-aos="fade-up" data-aos-delay="100">
              <Briefcase className="w-12 h-12 text-primary mx-auto mb-4" />
              <h3 className="text-xl font-bold text-primary mb-2">CRM System</h3>
              <p className="text-gray-600">Customer & lead management</p>
            </div>
            
            <div className="card bg-white text-center" data-aos="fade-up" data-aos-delay="200">
              <FileText className="w-12 h-12 text-primary mx-auto mb-4" />
              <h3 className="text-xl font-bold text-primary mb-2">Project Manager</h3>
              <p className="text-gray-600">Task tracking & collaboration</p>
            </div>
            
            <div className="card bg-white text-center" data-aos="fade-up" data-aos-delay="300">
              <TrendingUp className="w-12 h-12 text-primary mx-auto mb-4" />
              <h3 className="text-xl font-bold text-primary mb-2">Analytics</h3>
              <p className="text-gray-600">Business insights & reports</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-gold">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            {sp('cta_title')}
          </h2>
          <p className="text-xl text-primary-700 mb-8">
            {sp('cta_desc')}
          </p>
          <Link to="/contact" className="btn-primary">{common('request_quote')}</Link>
        </div>
      </section>
    </>
  );
};

export default CompanyManagement;
